<div class="crm-dashboard">
  <section class="crm-dashboard__grid">
    @for (card of cards; track card.section) {
      @if (card.observable | async; as cardData) {
        <app-card-crm
          class="crm-dashboard__card"
          prefixLabel="CRM.DASHBOARD."
          [routerLink]="!card.comingSoon ? card.link || undefined : undefined"
          [card]="card"
          [class.pointer]="!card.comingSoon"
        >
          @if (cardData.keys.length) {
            <app-table-card
              class="crm-dashboard__table-card"
              prefixLabel="CRM.DASHBOARD."
              [data]="cardData"
            ></app-table-card>
          } @else {
            <div class="crm-dashboard__loading">
              <app-loading [isBlock]="true"></app-loading>
            </div>
          }
        </app-card-crm>
      }
    }
  </section>

  @if (canSeeReport() && !!lookerUrl()) {
    <section class="crm-dashboard__report-section">
      <app-card-crm
        class="crm-dashboard__report-card"
        prefixLabel="CRM.DASHBOARD."
        [card]="{ title: 'REPORT', comingSoon: false, icon: 'icon-ipe-tower-chart' }"
        [seeAll]="true"
      >
        <div class="crm-dashboard__report-frame-wrap">
          <iframe
            class="crm-dashboard__report-frame"
            [src]="lookerSafeUrl()"
            frameborder="0"
            allowfullscreen
            sandbox="allow-storage-access-by-user-activation allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox allow-downloads"
          ></iframe>
        </div>
      </app-card-crm>
    </section>
  }
</div>
